import React, { useState, useEffect } from 'react';
import MeterCells from './MeterCells';
import PaymentsAPI from 'api/PaymentsAPI';

interface IUsageMeter {
  mainSub: any;
  meterSubs: any;
  handleTabChange: any;
  cusId: string;
  team: any;
}

const UsageMeter: React.FC<IUsageMeter> = ({ mainSub, meterSubs, handleTabChange, cusId, team }) => {
  const [ peopleInvoice, setPeopleInvoice ] = useState({ isLoading: true, data: '' });
  const [ productsInvoice, setProductsInvoice ] = useState({ isLoading: true, data: '' });
  const [ formsInvoice, setFormsInvoice ] = useState({ isLoading: true, data: '' });

  const convertAmount = (amount: any) => {
    const total = amount / 100;
    return total.toFixed(2);
  };

  const getMeterInvoices = async() => {
    meterSubs.data.map(async(sub: any) => {
      if (sub.metadata.moduleName === 'People') {
        const res2 = await PaymentsAPI.getMeterInvoice({ cus_id: cusId, subItemId: sub.subscription });
        if (res2?.success) {
          res2.result.lines.data.map((item: any) => {
            if (sub.id === item.subscription_item) {
              setPeopleInvoice({ isLoading: false, data: convertAmount(item.amount) });
            }
          });
        }
      }
      if (sub.metadata.moduleName === 'Products') {
        const res2 = await PaymentsAPI.getMeterInvoice({ cus_id: cusId, subItemId: sub.subscription });
        if (res2?.success) {
          res2.result.lines.data.map((item: any) => {
            if (sub.id === item.subscription_item) {
              setProductsInvoice({ isLoading: false, data: convertAmount(item.amount) });
            }
          });
        }
      }
      if (sub.metadata.moduleName === 'Forms') {
        const res2 = await PaymentsAPI.getMeterInvoice({ cus_id: cusId, subItemId: sub.subscription });
        if (res2?.success) {
          res2.result.lines.data.map((item: any) => {
            if (sub.id === item.subscription_item) {
              setFormsInvoice({ isLoading: false, data: convertAmount(item.amount) });
            }
          });
        }
      }
    });
  };

  useEffect(() => {
    getMeterInvoices();
  }, [ meterSubs ]);

  return (
    <div className='usage-meter-container'>
      <div className='usage-meter-content'>
        <div className='usage-meter-table'>
          <div className='overage-fees-table-header'>
            <div className='overage-fees-table-header-content'>
              <div className='overage-fees-table-header-text-group'>
                <div className='overage-fees-table-header-text-frame'>
                  <div className='overage-fees-table-header-title'>
                    Screening Usage Meters
                  </div>
                  <div
                    className='overage-fees-table-toggle'
                    onClick={() => {
                      handleTabChange('Plans');
                    }}
                  >
                    <div className='overage-fees-table-toggle-text'>
                      Manage Plans
                    </div>
                    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                      <path d='M5.83334 14.1663L14.1667 5.83301M14.1667 5.83301H5.83334M14.1667 5.83301V14.1663' stroke='#CECFD2' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='usage-meter-table-body'>
            <div className='usage-meter-table-end-column'>
              <div className='usage-meter-table-column-header'>
                <div className='usage-meter-table-column-header-frame'>
                  <div className='usage-meter-table-column-header-text'>
                    Screening Type
                  </div>
                </div>
              </div>
              <div style={{ padding: '23px 24px' }} className='usage-meter-row-cell'>
                <div className='overage-fees-row-cell-text-group'>
                  <div className='overage-fees-row-cell-text-primary'>
                    People/Companies
                  </div>
                </div>
              </div>
              <div style={{ padding: '23px 24px' }} className='usage-meter-row-cell'>
                <div className='overage-fees-row-cell-text-group'>
                  <div className='overage-fees-row-cell-text-primary'>
                    Products/Commodities
                  </div>
                </div>
              </div>
              <div style={{ padding: '23px 24px', border: 'none' }} className='usage-meter-row-cell'>
                <div className='overage-fees-row-cell-text-group'>
                  <div className='overage-fees-row-cell-text-primary'>
                    Supplier/Custom Forms
                  </div>
                </div>
              </div>
            </div>
            <div className='usage-meter-table-mid-column'>
              <div className='usage-meter-table-column-header'>
                <div className='usage-meter-table-column-header-frame'>
                  <div className='usage-meter-table-column-header-text'>
                    Usage
                  </div>
                </div>
              </div>
              {!mainSub.data.metadata ? (
                <></>
              ) : (
                <MeterCells
                  cusId={cusId}
                  type={mainSub.data.metadata.moduleName}
                  meterSubs={meterSubs}
                />
              )}
            </div>
            <div className='usage-meter-table-end-column'>
              <div className='usage-meter-table-column-header'>
                <div className='usage-meter-table-column-header-frame'>
                  <div className='usage-meter-table-column-header-text'>
                    Monthly Cost
                  </div>
                </div>
              </div>
              {!peopleInvoice.isLoading && (
                <div style={{ padding: '23px 24px' }} className='usage-meter-row-cell'>
                  <div className='overage-fees-row-cell-text-group'>
                    <div className='overage-fees-row-cell-text-secondary'>
                      ${peopleInvoice.data}
                    </div>
                  </div>
                </div>
              )}
              {!productsInvoice.isLoading && (
                <div style={{ padding: '23px 24px' }} className='usage-meter-row-cell'>
                  <div className='overage-fees-row-cell-text-group'>
                    <div className='overage-fees-row-cell-text-secondary'>
                      ${productsInvoice.data}
                    </div>
                  </div>
                </div>
              )}
              {!formsInvoice.isLoading && (
                <div style={{ padding: '23px 24px', border: 'none' }} className='usage-meter-row-cell'>
                  <div className='overage-fees-row-cell-text-group'>
                    <div className='overage-fees-row-cell-text-secondary'>
                      ${formsInvoice.data}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsageMeter;
